import { render, staticRenderFns } from "./Player.vue?vue&type=template&id=545da38d&scoped=true"
import script from "./Player.vue?vue&type=script&lang=js"
export * from "./Player.vue?vue&type=script&lang=js"
import style0 from "./Player.vue?vue&type=style&index=0&id=545da38d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545da38d",
  null
  
)

export default component.exports